package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_04_18_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to heroes on the edge of Gudin on the way north toward the Gideon forest. Elrovir greets two riders.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.QUOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Hello, Rangers. I am Elrovir Rodiridan of The Peers with the Friends of the Forest.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The riders introduce themselves as Sherry and Flinty. They ask about the situation in Highridge, which they heard about from refugees, and are relieved to hear that the heroes liberated the city.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Sherry asks Dirk about Dark Elves, and he mentions Captain Leah L’Seth of “The Cloud Chaser.” Sherry explains that a couple of days ago, two female Drow were seen in Gudin before they headed north.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Sherry points out the many points of interest in the town:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Slow Hare - tavern")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Cordon’s Commerce General Store - closes early, but if a traveler with coin to spend bangs on the door, the owner will likely open up.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday tells the refugees that Highridge is safe.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes bang on Cordon’s door, and he opens the shop. He tells the heroes that two beautiful Drow women visited his shop, purchasing 4 anti-toxin potions and healing potions. Cordon thinks they were from Mun (a mountainous region east of the Sea of Indifference), heading to the Gideon forest.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" “Mun” was misheard as “Moon.”")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes enter the Slow Hare tavern and order beer and rabbit stew from the lady Halfling bartender. She introduces herself as Jebby Thool. Dirk asks Jebby about the lady Drow who visited the town recently. They also visited the Slow Hare. They were polite guests and enjoyed rabbit stew just like the heroes are doing now. She describes them: ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Delia")
        }
        org.jetbrains.compose.web.dom.Text(": marvelous robes black, light blue, and purple ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Tressa")
        }
        org.jetbrains.compose.web.dom.Text(": metal armor")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes decide not to stay the night at the tavern because Dirk’s mansion is safer and more comfortable.")
    }
}
